import * as RouteNames from "@/employee/route-names";
import { elementsHomepageUrl } from "@/shared/elementsUrls";

export const footerTemplate = "ElementsFooter";

export const investmentRiskDisclaimer = null;

export const profileEditInformationHtml = "Please call {{partnerSupportPhone}} or log in to Elements online banking to make any updates to your information."
  + "<br />"
  + "Please note that changes may take 2-3 business days to be reflected.";

export const displayMyProfileEditMode = false;

export const logoutRedirectUrl = elementsHomepageUrl;

export const faqTemplate = "ElementsForms";

export const faqInstructionsTemplate = "ElementsFormsInstructions";

export const displayFaqInstructions = true;

export const faqLinkAddress = "https://www.bendhsa.com/en/elements-hsa-faq";

export const displayAdvice = true;

export const displayFaqExternalLinks = true;

export const displayInvestmentsSection = true;

export const disabledRouteRedirectTarget = null;

export const displaySettingsLinkedAccounts = true;

export const allowEmailEdit = false;

export const contactDetailsSetAtBank = false;

export const priorYearContributionOption = true;

export const allowReimbursement = true;

export const showPendingReimbursements = true;

export const showAlternateOnboardingCompleteMessage = false;

const disabledRoutesDictionary = {};

export const disabledRoutes = disabledRoutesDictionary;

export const feeTemplate = "TermsFeeSchedule";

export const cashAccountFooter = "Recent transaction corrections will be displayed within 3 business days.";
export const contributionsFooter = "Recent transaction corrections will be displayed within 3 business days.";

export const quarterlyPaperStatementFee = 1.5;

export const manageHsaCardsInPortal = false;

export const displayPriorYearContributionDisclaimerCopy = true;

export const displayProjectedContributions = true;

export const allowUserToEditContributions = true;

export const displayPdfForESign = false;

export const displayHealthcareBluebookLink = true;

export const displayFooterLegalSection = false;

export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = true;